import angular from 'angular';

export const EmptyStringToNullDirective = angular
  .module('angular-common.u-address.form.empty-string-to-null', [])
  .directive('emptyStringToNull', directive);

// This directive converts an empty string to null.
// This is needed in some cases where an empty input
// being set to an empty string would trigger a unnecessary
// change event.
function directive() {
  return {
    require: 'ngModel',
    link,
  };

  function link(scope, element, attrs, ctrl) {
    ctrl.$parsers.push(emptyStringToNull);
  }
}

function emptyStringToNull(value) {
  return value === '' ? null : value;
}
